import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@base/environments/environment';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { Overlay } from '@base/src/app/models/overlay.model';
import { QRDatePicker } from '@base/src/app/models/qr-date-picker.model';
import { RrhhTeamsListService } from '@base/src/app/services/rrhh/rrhh-teams-list.service';
import { SnackbarService } from '@base/src/app/services/snackbar.service';
import { UserSessionService } from '@base/src/app/services/user-session.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRChip } from 'src/app/models/qr-chip.model';
import { QRDialog } from 'src/app/models/qr-dialog.model';
import { QRInput } from 'src/app/models/qr-input.model';
import {
  AgentsWithoutTeam,
  NewTeam,
  MemberTeam,
} from 'src/app/models/rrhh.model';
import { UtilsService } from 'src/app/services/utils.service';

type InputTypes = string | number | undefined;
export interface Dates {
  startDate: string;
  dateFrom: string;
  dateTo: string;
  fullName: string;
}

@Component({
  selector: 'app-rrhh-team-members-form',
  templateUrl: './rrhh-team-members-form.component.html',
  styleUrls: ['./rrhh-team-members-form.component.scss'],
})
export class RrhhTeamMembersFormComponent implements OnInit {
  @Input() dataForServiceInfo!: NewTeam;
  @Input() agentsWithoutTeam: AgentsWithoutTeam[] = [];
  @Input() isEdit!: boolean;
  @Input() createdDate!: string;
  @Output() oneMemberAtLeast: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  agentList: { agent: AgentsWithoutTeam; selected: boolean }[] = [];
  originalAgentList: { agent: AgentsWithoutTeam; selected: boolean }[] = [];
  membersList: MemberTeam[] = [];
  someSearch = false;

  todayDate: string = moment().format('YYYY-MM-DD');

  inputSearch: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Buscar',
    icon: Constants.ICONS.SEARCH,
    // debounceTime: 500,
  };
  inputSearchValue: string | undefined;

  buttonIconDelete: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.TRASH,
    iconOnly: true,
  };
  buttonIconReactivate: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.RELOAD,
    iconOnly: true,
  };
  buttonIconInactivate: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.AGENT_OFF,
    iconOnly: true,
  };
  chipHierarchy2: QRChip = {
    hierarchy: QRChip.HIERARCHY_2,
    size: QRChip.SIZE_SMALL,
  };

  buttonIconAddAgent: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.AGENT_ADD,
    iconOnly: true,
  };

  buttonAddAgent: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.AGENT_ADD,
    viewValue: 'Agregar agentes',
  };

  buttonEditDate: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.PENCIL_BLUE,
    iconOnly: true,
  };

  emptyTeam = true;
  checkAll = false;
  btnAddAgentsIsDisabled = true;
  isLoading = false;
  animationOutIndex = -1;
  animationInIndex = -1;
  animationInRow: number[] = [];

  //DIALOGOS
  dialogConfirmReactivate: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '340px',
    title: 'Reactivar agente',
    textButtonAction: 'Sí, reactivar agente',
    textButtonCancel: 'Cancelar',
    componentToLoad: QRDialog.DIALOG_CONFIRM_REACTIVATE_MEMBER_TEAM,
    value: '',
  };
  memberToReactivateIndex = -1;

  showEmptyTableMembers = false;

  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_EC = Constants.TENANT_ID_EC;
  readonly NODE_DO = Constants.TENANT_ID_DO;

  overlay: Overlay = {
    isButtonCloseVisible: false,
    isFullHeight: true,
    doesClickingOutsideContentClose: true,
  };

  isOverlayVisible = false;
  fullName: string = '';
  agentId: number = 0;

  dialog: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '400px',
    title: 'Editar fecha de alta',
    textButtonAction: 'Guardar',
    textButtonCancel: 'Cancelar',
    value: '',
    isOverflowDisabled: true,
    componentToLoad: QRDialog.DIALOG_RRHH_CHANGE_DATE_AGENT,
  };

  datePickerFrom: QRDatePicker = { isDisplayedUp: false, calendarWidth: 200 };

  dialogEvent: DialogEvent = {
    isButtonActionDisabled: false,
    value: { dateFrom: undefined, dateTo: undefined },
  };

  datePickerEmpty: QRDatePicker = {
    date: '',
    calendarWidth: 224,
    isDisplayedUp: true,
    errorMsg: 'La fecha de baja no puede ser posterior al día actual.',
    maxDate: '',
  };

  agencyId: number = 0;
  userName: string = '';

  loggedUserSubscription: Subscription | undefined;
  loadedUserSesion = 1;

  datesToDatePicker: Dates = {
    startDate: '',
    dateFrom: '',
    dateTo: '',
    fullName: '',
  };

  constructor(
    private readonly utils: UtilsService,
    private readonly changeAgentDate: RrhhTeamsListService,
    private readonly userSessionService: UserSessionService,
    private readonly snackbarService: SnackbarService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    const members = this.dataForServiceInfo.members;
    this.membersList = [
      ...members.filter((item) => !item.endDate),
      ...members.filter((item) => item.endDate),
    ];

    this.onShowEmptyMembersImg();

    this.oneMemberAtLeast.emit(this.membersList.length > 0);

    if (this.agentsWithoutTeam) {
      this.agentsWithoutTeam.forEach((e) => {
        const item = {
          agent: e,
          selected: false,
        };
        this.agentList.push(item);
      });
    }
    const membersIDs = this.membersList.map(({ id }) => id);
    //Le quito los que eran miembros porque vienen en el servicio de agentes sin team
    this.agentList = this.agentList.filter(
      (a) => !membersIDs.includes(a.agent.id),
    );
    this.sortAgents();
    this.originalAgentList = this.agentList;
    this.getUserData();
  }

  /********************************/
  //////// FUNCIONES ÚTILES ////// /
  /********************************/

  sortAgents() {
    this.agentList = this.agentList.sort((a, b) =>
      a.agent.name.localeCompare(b.agent.name),
    );
  }

  formatDate(date: string | Date) {
    const day = date.toString();
    return this.utils.getFormattedDate(day);
  }

  formatDataForParent() {
    this.dataForServiceInfo.members = this.membersList;
    this.onShowEmptyMembersImg();
    this.oneMemberAtLeast.emit(this.membersList.length > 0);
  }

  onShowEmptyMembersImg() {
    this.showEmptyTableMembers =
      this.NODE == this.NODE_EC
        ? this.membersList.length == 0
        : this.membersList.length == 1;
  }

  //A la lista de agentes Le quita los miembros ya agregados
  updateAgentList() {
    const original = this.originalAgentList;
    this.agentList = original.filter(
      (e) => this.membersList.findIndex((memb) => e.agent.id == memb.id) == -1,
    );
  }

  getIndexFirstInactive(): number {
    return this.membersList.findIndex((e) => e.endDate);
  }

  //Agrega un nuevo miembro antes de los inactivos (los inactivos van al final)
  addMemberBeforeInactives(memberToAdd: MemberTeam) {
    const indexFirstInactive = this.getIndexFirstInactive();

    if (indexFirstInactive == -1) {
      this.membersList.push(memberToAdd);
    } else {
      this.membersList.splice(indexFirstInactive, 0, memberToAdd);
    }
  }

  //Limpia las row, les saca animacion ya ejecutada
  clearInAnimation() {
    setTimeout(() => {
      this.animationInRow = [];
    }, 200);
  }

  private isValidMemberSplitDO(agent: AgentsWithoutTeam): boolean {
    if (this.NODE !== this.NODE_DO) {
      return true;
    }

    if (
      agent.agentTypeKey == null ||
      this.dataForServiceInfo.agentTypeKey == null
    ) {
      this.snackbarService.openSnackBar(
        'No se pudo validar el split del agente. Contactese con soporte.',
        '',
      );
      return false;
    }

    if (agent.agentTypeKey > this.dataForServiceInfo.agentTypeKey) {
      this.snackbarService.openSnackBar(
        'El split del agente ' +
          agent.name +
          ' ' +
          agent.lastname +
          ' es superior al split del Team Leader.',
        '',
      );
      return false;
    }

    return true;
  }

  /*********************************/
  ///// INTERACCIÓN DEL USUARIO /////
  /*********************************/

  //BÚSQUEDA 🔍
  inputSearchChange(value: InputTypes): void {
    if (value) {
      const search = this.utils.textNormalize(value);
      this.agentList = this.agentList.filter(
        (e) =>
          this.utils.textNormalize(e.agent.name).includes(search) ||
          this.utils.textNormalize(e.agent.lastname).includes(search),
      );
    } else {
      this.updateAgentList();
    }
  }

  //Checkea si el btn "agregar agentes" debe estar disabled o no
  checkBtnAddAgentsStatus() {
    this.btnAddAgentsIsDisabled = !this.agentList.some((item) => item.selected);
  }

  // CHECK "TODOS" ☑
  onCheckAll(event: boolean) {
    this.checkAll = event;
    this.agentList.forEach((e) => {
      e.selected = event;
    });
    this.checkBtnAddAgentsStatus();
  }

  //SELECCIONAR 1 AGENTE ☑
  checkboxAgentsChange(e: boolean, i: number): void {
    this.agentList[i].selected = e;
    this.checkBtnAddAgentsStatus();
    this.checkAll = !this.agentList.some((item) => !item.selected);
  }

  // BTN: AGREGAR AGENTES
  onAddAgents() {
    const list = this.agentList;
    if (!this.btnAddAgentsIsDisabled) {
      list.forEach((e) => {
        if (e.selected) {
          if (!this.isValidMemberSplitDO(e.agent)) {
            return;
          }

          const item: MemberTeam = {
            id: e.agent.id,
            startDate: this.todayDate,
            endDate: '',
            lastname: e.agent.lastname,
            name: e.agent.name,
            leader: false,
            isNew: true,
          };
          this.addMemberBeforeInactives(item);
          this.animationInRow.push(
            this.getIndexFirstInactive() != -1
              ? this.getIndexFirstInactive() - 1
              : this.membersList.length - 1,
          );
        }
      });
      this.clearInAnimation();

      this.inputSearchValue = Object.assign('', '');
      this.checkAll = false;
      this.onCheckAll(false);
      this.checkBtnAddAgentsStatus();
      this.updateAgentList();
      this.formatDataForParent();
    }
  }

  // BTN: AGREGAR UN AGENTE
  onAddOneAgent(id: number) {
    const AGENT_TO_ADD = this.agentList.find((a) => a.agent.id == id);
    if (AGENT_TO_ADD) {
      const memberToAdd: MemberTeam = {
        id: AGENT_TO_ADD.agent.id,
        startDate: this.todayDate,
        endDate: '',
        lastname: AGENT_TO_ADD.agent.lastname,
        name: AGENT_TO_ADD.agent.name,
        leader: false,
        isNew: true,
      };

      if (!this.isValidMemberSplitDO(AGENT_TO_ADD.agent)) {
        return;
      }

      this.animationInRow =
        this.getIndexFirstInactive() == -1
          ? [this.membersList.length]
          : [this.getIndexFirstInactive()];

      this.addMemberBeforeInactives(memberToAdd);

      this.clearInAnimation();

      this.agentList = this.agentList.filter((e) => e.agent.id != id);
      this.checkBtnAddAgentsStatus();
      if (this.agentList.length == 0) {
        this.inputSearchValue = Object.assign('', '');
        this.updateAgentList();
      }
      this.formatDataForParent();
    }
  }

  //ELIMINAR UN MIEMBRO DEL TEAM
  onRemoveMember(id: number, index: number) {
    this.animationOutIndex = index;
    setTimeout(() => {
      this.animationOutIndex = -1;
      //Al editar un team si elimino un miembro del team se desactiva
      //sino (si es nuevo) vuelve a la lista de agentes sin team
      if (this.membersList[index].isNew) {
        this.membersList = this.membersList.filter((e) => e.id != id);
        this.updateAgentList();
        this.onCheckAll(false);
      } else {
        const memberToInactivate = this.membersList[index];
        memberToInactivate.endDate = this.todayDate;
        this.membersList.splice(index, 1);
        this.membersList.push(memberToInactivate);

        this.animationInRow = [this.membersList.length - 1];
        this.clearInAnimation();
      }
      this.formatDataForParent();
    }, 200); //Animacion de eliminar
  }

  //REACTIVAR MIEMBRO INACTIVO
  reactivateMember(index: number) {
    this.memberToReactivateIndex = index;
    this.dialogConfirmReactivate = {
      ...this.dialogConfirmReactivate,
      isVisible: true,
    };
  }

  dialogReactivateMemberChange(): void {
    const member = this.membersList.splice(this.memberToReactivateIndex, 1)[0];
    member.endDate = '';
    member.startDate = this.todayDate;

    this.animationInRow =
      this.getIndexFirstInactive() == -1
        ? [this.membersList.length]
        : [this.getIndexFirstInactive()];

    this.addMemberBeforeInactives(member);
    this.clearInAnimation();

    this.memberToReactivateIndex = -1;
  }

  getUserData() {
    this.loggedUserSubscription = this.userSessionService.loggedUser$.subscribe(
      async (loggedUser: any) => {
        if (loggedUser != null && this.loadedUserSesion == 1) {
          this.loadedUserSesion += 1;
          if (loggedUser.agency_id) {
            this.agencyId = loggedUser.agency_id;
            this.userName = loggedUser.username;
          }
        }
      },
    );
  }

  onEditDate(
    id: number,
    name: string,
    lastname: string,
    dateStart: string,
  ): void {
    this.agentId = id;
    this.fullName = name + ' ' + lastname;
    this.datesToDatePicker = {
      startDate: dateStart,
      dateFrom: this.createdDate,
      dateTo: moment().format('YYYY-MM-DD'),
      fullName: this.fullName,
    };
    this.dialog = {
      ...this.dialog,
      isVisible: true,
      value: this.datesToDatePicker,
    };
  }

  dialogChange(dateChanged: string): void {
    const DTO = {
      agencyId: this.agencyId,
      loggedUser: this.userName,
      newDischargeDate: dateChanged,
      id: this.agentId,
    };
    this.changeAgentDate.changeAgentDischargeDate(DTO).subscribe({
      next: () => {
        this.snackbarService.openSnackBar(
          '✅ Fecha de alta actualizada correctamente.',
          '',
        );
        sessionStorage.setItem('selectedFormIndex', '1');
        setTimeout(() => {
          this.router.navigate(['/rrhh/']);
        }, 300);
      },
      error: (err) => console.error('Error al actualizar la fecha', err),
    });
  }
}
